import * as React from "react";
import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <>
    <rect className="Radio" x="3.5" y="3.5" width="19" height="19" rx="9.5" />
    <rect
      className="Radio-focus"
      x="1.5"
      y="1.5"
      width="23"
      height="23"
      rx="11.5"
      stroke="#1AD4FD"
      strokeWidth="3"
    />
  </>,
  "AcUnit"
);
